import React from 'react';
import { Hero } from '../sections/Hero';
import { WhoStrip } from '../sections/WhoStrip';
import { CredibilityStrip } from '../sections/CredibilityStrip';
import { ProblemRecognition } from '../sections/ProblemRecognition';
import { FrameworkOverview } from '../sections/FrameworkOverview';
import { LeadMagnet } from '../sections/LeadMagnet';
import { WhyMGS } from '../sections/WhyMGS';
import { ResourcesPreview } from '../sections/ResourcesPreview';
import { InsightsPreview } from '../sections/InsightsPreview';
import { FieldNotes } from '../sections/FieldNotes';
import { ContactQuestion } from '../sections/ContactQuestion';
import { FAQ } from '../sections/FAQ';
import { FinalCTA } from '../sections/FinalCTA';
interface HomeProps {
  onDownload: (title?: string) => void;
}
export function Home({
  onDownload
}: HomeProps) {
  return <>
      <Hero onDownload={() => onDownload()} data-id="element-316" />
      <WhoStrip data-id="element-317" />
      <CredibilityStrip data-id="element-318" />
      <ProblemRecognition data-id="element-319" />
      <FrameworkOverview data-id="element-320" />
      <LeadMagnet data-id="element-321" />
      <WhyMGS onDownload={() => onDownload()} data-id="element-322" />
      <ResourcesPreview onOpenResource={title => onDownload(title)} data-id="element-323" />
      <InsightsPreview data-id="element-324" />
      <FieldNotes data-id="element-325" />
      <ContactQuestion onDownload={() => onDownload()} data-id="element-326" />
      <FAQ onDownload={() => onDownload()} data-id="element-327" />
      <FinalCTA onDownload={() => onDownload()} data-id="element-328" />
    </>;
}